import(/* webpackMode: "eager" */ "/home/i2k2admin/RestroAgent/RestroAgent/src/app/(landing)/cookie/page.tsx");
